import * as types from './stockStatusActionTypes'

export const getStockStatusRequestAction = (payload) => ({
  type: types.GET_STOCK_STATUS_REQUEST,
  payload,
})

export const getStockStatusDataAction = (payload) => ({
  type: types.GET_STOCK_STATUS_DATA,
  payload,
})

export const getStockStatusErrorAction = (payload) => ({
  type: types.GET_STOCK_STATUS_ERROR,
  payload,
})

export const createStockStatusRequestAction = (payload) => ({
  type: types.CREATE_STOCK_STATUS_REQUEST,
  payload,
})

export const createStockStatusDataAction = (payload) => ({
  type: types.CREATE_STOCK_STATUS_DATA,
  payload,
})

export const createStockStatusErrorAction = (payload) => ({
  type: types.CREATE_STOCK_STATUS_ERROR,
  payload,
})

export const updateStockStatusRequestAction = (payload) => ({
  type: types.UPDATE_STOCK_STATUS_REQUEST,
  payload,
})

export const updateStockStatusDataAction = (payload) => ({
  type: types.UPDATE_STOCK_STATUS_DATA,
  payload,
})

export const updateStockStatusErrorAction = (payload) => ({
  type: types.UPDATE_STOCK_STATUS_ERROR,
  payload,
})

export const deleteStockStatusRequestAction = (payload) => ({
  type: types.DELETE_STOCK_STATUS_REQUEST,
  payload,
})

export const deleteStockStatusDataAction = (payload) => ({
  type: types.DELETE_STOCK_STATUS_DATA,
  payload,
})

export const deleteStockStatusErrorAction = (payload) => ({
  type: types.DELETE_STOCK_STATUS_ERROR,
  payload,
})

export const sortStockStatusHistorySortData = (payload) => ({
  type: 'SET_STOCK_HISTORY_SORT_DATA',
  payload,
})

export const sortingStockStatusHistoryAction = (payload) => ({
  type: 'SORTING_STOCK_HISTORY_ACTION',
  payload,
})

export const SET_STOCK_HISTORY_SORT_DATA = 'SET_STOCK_HISTORY_SORT_DATA'
export const SORTING_STOCK_HISTORY_ACTION = 'SORTING_STOCK_HISTORY_ACTION'
